import { FCC } from "@/types/common";
import { Grid, Stack, styled, Typography } from "@mui/material";
import { black } from "@/theme/colors";
import dayjs from "dayjs";
import { DATE_FORMAT } from "@/constants/datetime";

type TCompanyTitle = {
  managementNumber?: string | null | undefined;
  title?: string | null | undefined;
  createdAt?: string | null | undefined;
  updatedAt?: string | null | undefined;
};

export const CompanyTitle: FCC<TCompanyTitle> = ({ managementNumber, title, createdAt, updatedAt }) => {
  const titleFinal = title ? title : "新規企業登録";

  return (
    <TitleContainer>
      <Stack>
        <Stack direction="row" alignContent="center" alignItems="center" gap={2} mb={4}>
          <Typography variant="head24Bold">{titleFinal}</Typography>
        </Stack>
        <Grid container gap={2}>
          <Typography variant="body14Light" color={black[70]}>
            管理番号：{managementNumber || "----"}
          </Typography>
          {createdAt && (
            <Typography variant="body14Light" color={black[70]}>
              登録日時：{dayjs(createdAt).isValid() ? dayjs(createdAt).format(DATE_FORMAT) : ""}
            </Typography>
          )}
          {updatedAt && (
            <Typography variant="body14Light" color={black[70]}>
              更新日時：{dayjs(updatedAt).isValid() ? dayjs(updatedAt).format(DATE_FORMAT) : ""}
            </Typography>
          )}
        </Grid>
      </Stack>
    </TitleContainer>
  );
};

const TitleContainer = styled(Stack)`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: self-start;
  margin-bottom: 8px;
`;
